import * as React from 'react';
import { Radio } from '@cian/ui-kit';

import { IRegion } from '../../types/region';

import * as style from './RegionItem.css';

export interface IRegionItemProps {
  region: IRegion;
  checked: boolean;
  onChange: (region: IRegion) => void;
}

export const RegionItem: React.FC<IRegionItemProps> = props => {
  const { onChange, checked, region } = props;

  const handleChange = React.useCallback(
    (newRegion: IRegion) => () => {
      onChange(newRegion);
    },
    [onChange],
  );

  return (
    <div className={style['container']}>
      <Radio
        name={region.displayName}
        label={region.displayName}
        checked={checked}
        value={String(region.id)}
        onChange={handleChange(region)}
      />
    </div>
  );
};
